import { register } from '../component.js';
import 'react';
var _socialIcons_flickr = register("flickr", {
  "color": "#0063db",
  "path": "M38 27c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5M0 0v64h64V0zm32 48c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16m-6-21c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5"
});
export { _socialIcons_flickr as default };